module.exports = __webpack_public_path__ + "static/media/quote-covey-listen-fr.8ed97142.png";